<tr>
  <td colspan="100%">
    <div class="paginate-container">
      <div class="per-page">
        <app-select [formControl]="paginate.controls.perPage">
          <app-option *ngFor="let option of perPageOptions" [value]="option">
            {{ option }}
          </app-option>
        </app-select>
      </div>

      <div class="pages">
        <button
          type="button"
          app-button
          appearance="basic"
          color="neutral"
          class="btn btn--chevron"
          (click)="onPreviousPage()"
        >
          <i class="icon--chevron-left"></i>
        </button>

        <ng-container *ngFor="let page of pages">
          <ng-container
            *ngTemplateOutlet="page === '...' ? dotsTmpl : buttonTmpl; context: { $implicit: page }"
          >
          </ng-container>
        </ng-container>

        <button
          type="button"
          app-button
          appearance="basic"
          color="neutral"
          class="btn btn--chevron"
          (click)="onNextPage()"
        >
          <i class="icon--chevron-right"></i>
        </button>
      </div>
    </div>
  </td>
</tr>

<ng-template #dotsTmpl>
  <span class="paginate__dots">…</span>
</ng-template>

<ng-template #buttonTmpl let-page>
  <button
    type="button"
    app-button
    [appearance]="paginate.controls.page.value === page ? 'filled' : 'basic'"
    [color]="paginate.controls.page.value === page ? 'primary' : 'neutral'"
    (click)="onPageChange(page)"
  >
    {{ page }}
  </button>
</ng-template>
